module.exports = __webpack_public_path__ + "static/muriel-96a48987a30cbdb623e82df7edfdc397.jpg";